<template>
  <div class="reports__panel--yearmonth">
    <b-field :label="label">
      <dropdown :sourceList="options"
                :keyPropertyName="(o) => o.value"
                :displayPropertyName="(o) => o.label"
                @selectionChanged="selectionChanged">
      </dropdown>
    </b-field>

  </div>
</template>

<script>
import Dropdown from '@/components/common/Dropdown.vue';
import moment from 'moment';

export default {
  name: 'reports-panel-yearmonth',
  components: { Dropdown },
  props: {
    offsetMonth: {
      type: Number,
      default: 0
    },
    selected: {
      type: Object
    },
    firstRun: {},
    label: {
      type: String,
      default: 'Måned, År'
    },
  },
  data: () => ({
    options: [],
    selectedObject: Object
  }),
  mounted() {
    this.options = this.buildOptions();
  },
  methods: {
    buildOptions() {
      const options = [];
      let date = moment();
      options.push({
        value: {
          month: moment(date).month(),
          year: moment(date).year()
        },
        label: moment(date).format("MMMM, YYYY"),
        isSelected: true
      });
      if(this.offsetMonth > 0) {
        for (let i = 1; i < this.offsetMonth; i++) {
          date = moment(date).add(1, 'months');
          options.push({
            value: {
              month: moment(date).month(),
              year: moment(date).year()
            },
            label: moment(date).format("MMMM, YYYY"),
            isSelected: false
          });
        }
      }

      date = moment();
      const totalMonth = 12 + moment(date).month() + 1;
      for (let i = 1; i < totalMonth; i++) {
        date = moment(date).subtract(1, 'months');
        options.push({
          value: {
            month: moment(date).month(),
            year: moment(date).year()
          },
          label: moment(date).format("MMMM, YYYY"),
          isSelected: false,
          backgroundColor: this.offsetMonth > 0 ? 'yellow' : 'inherit'
        });
      }
      return options;
    },
    selectionChanged(value) {
      this.$emit('year', value.year);
      this.$emit('month', value.month);
    }
  },
  computed: {

  },
  watch: {
    'selected'(newValue) {
      if(this.options !== undefined){
        const index = this.options.indexOf(this.options.find(o => o.value.month === newValue.month));
        this.options[index].isSelected = true;
      }
    }
  }
}
</script>

<style lang="scss">
.reports__panel--yearmonth {
  .ctrl-button {
    padding-left: 10px !important;
  }
}
</style>